import React, { useEffect, useState } from 'react';
import { Button, Container, Form } from "react-bootstrap";
import Spinner from "react-bootstrap/Spinner";
import { createUserAdmin, deleteUserAdminById, getAllAdminUsers, updateUserAdminById } from '../../api/apiAdmin';
import { myId } from '../../lib/MyLibrary';
import { FiEye,FiEyeOff } from 'react-icons/fi';


const initialData= {
  user: '',
  password: ''
}

const RootUser = () => {
  const [newAdminUser, setNewAdminUser] = useState(initialData);
  const [usersAdminInDB, setUsersAdminInDB] = useState('');
  const [updateUserAdminByIdData, setUpdateUserAdminByIdData]= useState('');
  const [isUpdate, setIsUpdate] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  useEffect(() => {
    if(!newAdminUser.user&&!newAdminUser.password)
    setIsUpdate(false)
    return 
  }, [newAdminUser]);
  

  const handleNewUser = async (e)=>{
    e.preventDefault();
    if(isUpdate){
      const id= updateUserAdminByIdData._id;
      const data= newAdminUser;
      const result = await updateUserAdminById(id,data);
      console.log('Usuario Actualizado:..',result);
      if(result) setNewAdminUser(initialData);
    }else{
      console.log('crearemos un usuario nuevo:..');
      const result = await createUserAdmin(newAdminUser);
      console.log('resultCreateNewUserAdmin:..', result);
      if(result) setNewAdminUser(initialData);
    }
    
  }
  const handleChange= (e)=>{
    e.preventDefault();
    //console.log(e.target.name,e.target.value);
    
    
    
    setNewAdminUser({
      ...newAdminUser,
      [e.target.name]: e.target.value
    })
  }
  const getAllAdminUsersinDB= async()=>{
    
    console.log('Recuperando datos de la DB:..');
    const result = await getAllAdminUsers();
    console.log('Result getAllAdminUsers:..',result);
    if(result.response.data.result){
      console.log('Data successfull recovery...');
      setUsersAdminInDB(result.response.data.result);
    } else{
      console.log('Error:..',result);
    }
    
  }
  const handleDeleteUser = async(e)=>{
    const deleteUserID = e.target.name;
    const result = await deleteUserAdminById(deleteUserID);
    console.log('Eliminando user:..',result);
  }
  const handleEditUser = async(e)=>{
    const userEditID = e.target.name;
    const dataUserEdit = usersAdminInDB.find(item=>item._id===userEditID);
    setNewAdminUser({
      user: dataUserEdit.user,
      password: dataUserEdit.password
    })
    setUpdateUserAdminByIdData(dataUserEdit);
    setIsUpdate(true);
  }
  const toggleShowPassword = ()=>{
    setShowPassword(prev=>!prev);
  }
  return (
    <div className='bg-secondary bg-opacity-25 p-3 mb-3'>
      <Form>
        <Container className='w-50'>
          <Form.Group>
            <Form.Label>User</Form.Label>
            <Form.Control value={newAdminUser.user} name='user' onChange={handleChange} type='text' placeholder='user'/>
          </Form.Group>
          <Form.Group>
            <Form.Label>Password</Form.Label>
            <div className='d-flex w-100'>
            <Form.Control value={newAdminUser.password} name='password' onChange={handleChange} type={showPassword?'text':'password'} placeholder='password'/>
            <Button onClick={toggleShowPassword} className='btn btn-light'>{showPassword?<FiEyeOff/>:<FiEye/>}</Button>
            </div>
          </Form.Group>
        </Container>
        <Button onClick={handleNewUser} className='w-25 d-block ms-auto me-auto my-3'>{isUpdate?'Update':'Create New'} userAdmin</Button>
      </Form>
      <Button onClick={getAllAdminUsersinDB} className='w-25 d-block ms-auto me-auto my-3 btn-secondary'>Get All Admin Users</Button>
      {usersAdminInDB && <div className='border border-2 p-3 m-3 w-50 ms-auto me-auto bg-dark bg-opacity-10 rounded'>
        {usersAdminInDB.map((item)=>{
        return <h6 key={myId()} className='d-flex justify-content-between'>
          <div>User: <span className='fs-4'>{item.user}</span></div>
          <div className=''>
          <button onClick={handleEditUser} name={item._id} className='btn btn-secondary me-2'>✏️</button>
          <button onClick={handleDeleteUser} name={item._id} className='btn btn-danger'>🗑️</button>
          </div>
          </h6>
      })}
      </div>
      }
    </div>
  )
}

export default RootUser